//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  methods: {
    getFileIcon(type) {
      try {
        const file = require(`~/assets/img/base/files/${type.toLowerCase()}.svg`)
        return file
      } catch (error) {
        const defaultFile = require(`~/assets/img/base/files/default.svg`)
        return defaultFile
      }
    },

    downloadFile(file) {
      window.open(file.url, '_blank')
    }
  }
}
